import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DebtorInfo } from '../../entities/InvoicePortal';

interface DebtorHeaderProps {
  debtorInfo: DebtorInfo;
  totalDebt: number;
  currency: string;
}

export const DebtorHeader: React.FC<DebtorHeaderProps> = ({
  debtorInfo,
  totalDebt,
  currency,
}) => {
  const theme = useTheme();

  const formatAmount = (amount: number, currency: string) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  };

  // Función para capitalizar el nombre
  const capitalizeName = (name: string) => {
    return name.toLowerCase().replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        py: { xs: 3, sm: 4 },
      }}
    >
      <Container maxWidth="md" sx={{ px: { xs: 2, sm: 3 } }}>
        {/* Nombre del deudor - capitalizado */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            mb: 1,
            fontSize: { xs: '1.75rem', sm: '2.125rem' },
            letterSpacing: '-0.02em',
            textAlign: 'center',
          }}
        >
          {capitalizeName(debtorInfo.name)}
        </Typography>

        {/* CUIL debajo del nombre */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontWeight: 500,
            textAlign: 'center',
            mb: 3,
            opacity: 0.8,
          }}
        >
          CUIL: {debtorInfo.tax_id_number}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            fontWeight: 500,
            textAlign: 'center',
            mb: 3,
          }}
        >
          Monto adeudado
        </Typography>

        {/* Deuda total - prominente como Apple Pay */}
        <Typography
          variant="h1"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: { xs: '2.5rem', sm: '3.5rem' },
            letterSpacing: '-0.02em',
            textAlign: 'center',
            lineHeight: 1,
          }}
        >
          {formatAmount(totalDebt, currency)}
        </Typography>
      </Container>
    </Box>
  );
};
